import angular from 'angular';
import * as devices from '../../modules/devices';
import { constants, helpers } from '../../modules/dokbot';
export class PreCallLauncher {
    constructor($window, notificationFactory, globalUi, $timeout, $rootScope, $translate, Browser, VideoProviderFactory, $ngRedux, pn) {
        this.$window = $window;
        this.notificationFactory = notificationFactory;
        this.globalUi = globalUi;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.Browser = Browser;
        this.VideoProviderFactory = VideoProviderFactory;
        this.$ngRedux = $ngRedux;
        this.pn = pn;
        this.launcher = null;
        this.runtime = null;
        this.startInSeparateTab = null;
        this.isClosing = false;
        this.isOnPrecallTest = false;
        this.doEnableSelfViewCamera = false;
        this.canCausePublisherIssues = false;
        this.initLauncher();
        this.cancelPrecallTestHandler();
    }
    initLauncher() {
        this.canCausePublisherIssues = this.Browser.isIos();
        if (!this.$window.Dokbot || !this.$window.Dokbot.meta.isBrowserSupported) {
            // if Dokbot is not loaded or blocked by firewalls etc.,
            // the precall-test page will be opened in standalone mode.
            // and if there Dokbot is not loaded also,
            // it will show 'Unsupported' page.
            this.startInSeparateTab = true;
            helpers.dokbotTrackError(constants.DOKBOT_TYPE_PRECALL);
        }
        else {
            const updateVideoProviderConfig = () => {
                if (this.canCausePublisherIssues) {
                    this.VideoProviderFactory.activeProvider.initPublisher();
                }
                if (this.doEnableSelfViewCamera) {
                    this.VideoProviderFactory.activeProvider.enableWebcam();
                }
            };
            this.launcher = this.$window.Dokbot.RuntimeComponent.overlay({
                workflowId: 'doxyme-troubleshooting',
                consultationId: '+',
                params: { noredirect: true },
                closeButton: true,
                onEvent: (event) => {
                    if (event.name === 'finishSuccess') {
                        const isPatient = this.pn.isPatient();
                        const hasMediaAccess = devices.selectors.hasMediaAccess(this.$ngRedux.getState());
                        this.doEnableSelfViewCamera = isPatient && !hasMediaAccess;
                    }
                },
                onClose: () => {
                    updateVideoProviderConfig();
                    this.clearRuntime();
                    this.isOnPrecallTest = false;
                },
                errorKitOverride: {
                    id: constants.DOKBOT_KIT_ID,
                    url: constants.DOKBOT_KIT_URL,
                },
            }, {
                preload: true,
                explosionColor: '#0f1722',
                overlayCloseable: true,
            });
        }
    }
    clearRuntime() {
        this.runtime = null;
    }
    cancelPrecallTestHandler() {
        this.$rootScope.$on('DoxybotPrecallTest:cancel', () => {
            if (!this.isOnPrecallTest)
                return;
            this.notificationFactory.showCommon('success', this.$translate.instant('notification.precallTestCancelled'));
            if (this.runtime) {
                this.$timeout(() => {
                    this.runtime.close();
                    this.isOnPrecallTest = false;
                    this.clearRuntime();
                }, this.globalUi.PRECALL_TEST_CANCEL_DELAY);
            }
            else {
                this.isClosing = true;
            }
        });
    }
    async preCallTest(e) {
        if (this.canCausePublisherIssues) {
            this.VideoProviderFactory.activeProvider.destroyPublishers();
        }
        if (this.startInSeparateTab) {
            this.$window.open('/precall-test');
            return;
        }
        this.isOnPrecallTest = true;
        this.runtime = await this.launcher(e);
        if (this.isClosing) {
            this.runtime.close();
            this.isClosing = false;
            this.clearRuntime();
            this.isOnPrecallTest = false;
        }
    }
}
export default angular
    .module('doxy.common.services.preCallLauncher', [])
    .service('preCallLauncher', PreCallLauncher).name;
